import React, { useState, useEffect, useMemo } from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import { checkUserPermission } from "../../common/UserPermission";
import config from "../../config/config";
import DataTable from "react-data-table-component";
import moment from "moment";
import Select from "react-select";
import MaterialReactTable from "material-react-table";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import { Box, Button, MenuItem } from "@mui/material";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
const Paymentlisting = ({ customerid }) => {
  let PERMISSION_EDIT = "/manage-customers/:id";
  let PERMISSION_DELETE = "delete-customers";

  const [data, setData] = useState([]);
  const [title, setTitle] = useState("");
  const [loading, setLoading] = useState(false);
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [perPageSize, setperPageSize] = useState(25);
  const [toggleCleared, setToggleCleared] = useState(false);
  const [sortingId, setSortingId] = useState(3);
  const [sortingDirection, setSortingDirection] = useState("desc");
  const [searchtext, setSearchText] = useState("");
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedSalesCheckboxIds, setselectedSalesCheckboxIds] = useState("");
  const [startingDate, setStartingDate] = useState("");
  const [endingDate, setEndingDate] = useState("");
  const [salesTypeID, setSalesTypeID] = useState(0);
  const [customerID, setCustomerID] = useState(0);
  const paramObject = useParams();
  const token = localStorage.getItem("Token");
  const [pagenumber, setPageNumber] = useState(1);
  const [pagesize, setPageSize] = useState(10);
  const [filtertext, setFilterText] = useState("");
  const [ordercolumn, setOrderColumn] = useState("");
  const [currentorder, setCurrentOrder] = useState("");
  const [customStartingDate, setCustomStartingDate] = useState();
  const [customEndingDate, setCustomEndingDate] = useState();
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const deleteRequestParam = localStorage.getItem("DeleteRequestParam");

  //table state
  const [columnFilters, setColumnFilters] = useState([]);
  const [globalFilter, setGlobalFilter] = useState("");
  const [sorting, setSorting] = useState([]);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const [quickBookOptions, setQuickBookOptions] = useState({
    label: "All",
    value: 1,
  });

  const options = [
    { label: "All", value: 1 },
    { label: "Today", value: 7 },
    { label: "Last Day", value: 8 },
    { label: "Current Week", value: 4 },
    { label: "Last Week", value: 3 },
    { label: "Current Month", value: 6 },
    { label: "Last Month", value: 5 },
    { label: "Custom", value: 2 },
  ];

  const handleSearchAccordingToDate = () => {
    handleListData(
      1,
      perPageSize,
      searchtext,
      sortingId,
      sortingDirection,
      startingDate,
      endingDate
    );
  };

  const handleChangeCustomStartingDate = (event) => {
    console.log("event starting ==> ", event.target.value);
    setCustomStartingDate(event.target.value);
    setStartingDate(event.target.value);
  };

  const handleChangeCustomEndingDate = (event) => {
    // console.log("event ending ==> ", event.target.value);
    setCustomEndingDate(event.target.value);
    setEndingDate(event.target.value);
  };

  const handleQuickBookChange = (event) => {
    setQuickBookOptions(event);

    // All Condition
    if (event?.value == 1) {
      setStartingDate("");
      setEndingDate("");
    }
    // Custom Condition
    else if (event?.value == 2) {
      setStartingDate(customStartingDate);
      setEndingDate(customEndingDate);
    }
    // Last Week Condition
    else if (event?.value == 3) {
      const lastWeekStartDate = moment()
        .subtract(1, "week")
        .startOf("week")
        .format("YYYY-MM-DD");
      const lastWeekEndDate = moment()
        .subtract(1, "week")
        .endOf("week")
        .format("YYYY-MM-DD");

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Current Week Condition
    else if (event?.value == 4) {
      const lastWeekStartDate = moment().startOf("week").format("YYYY-MM-DD");
      const lastWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");
      console.log(
        "lastWeekStartDate: " + lastWeekStartDate,
        "| " + "lastWeekEndDate" + lastWeekEndDate
      );

      setStartingDate(lastWeekStartDate);
      setEndingDate(lastWeekEndDate);
    }
    // Last Month Condition
    else if (event?.value == 5) {
      const lastMonthStartDate = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      const lastMonthEndDate = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");

      setStartingDate(lastMonthStartDate);
      setEndingDate(lastMonthEndDate);
    }
    // Current Month Condition
    else if (event?.value == 6) {
      const firstdate = moment().startOf("month").format("YYYY-MM-DD");
      const lastdate = moment().endOf("month").format("YYYY-MM-DD");

      setStartingDate(firstdate);
      setEndingDate(lastdate);
    } else if (event?.value == 7) {
      setStartingDate(moment().startOf("day").format("YYYY-MM-DD"));
      setEndingDate(moment().startOf("day").format("YYYY-MM-DD"));
    } else if (event?.value == 8) {
      const yesterday = moment().subtract(1, "days").format("YYYY-MM-DD");
      setStartingDate(yesterday);
      setEndingDate(yesterday);
    } else {
      setStartingDate("");
      setEndingDate("");
    }
  };

  // useEffect(() => {
  //   if (quickBookOptions?.value == 1) {
  //     setStartingDate("");
  //     setEndingDate("");
  //   }
  //   // Custom Condition
  //   // else if (quickBookOptions?.value == 2) {
  //   //   setStartingDate(customStartingDate);
  //   //   setEndingDate(customEndingDate);
  //   // }
  //   // Last Week Condition
  //   else if (quickBookOptions?.value == 3) {
  //     const lastWeekStartDate = moment()
  //       .subtract(1, "week")
  //       .startOf("week")
  //       .format("YYYY-MM-DD");
  //     const lastWeekEndDate = moment()
  //       .subtract(1, "week")
  //       .endOf("week")
  //       .format("YYYY-MM-DD");

  //     setStartingDate(lastWeekStartDate);
  //     setEndingDate(lastWeekEndDate);
  //   }
  //   // Current Week Condition
  //   else if (quickBookOptions?.value == 4) {
  //     const currentWeekStartDate = moment()
  //       .startOf("week")
  //       .format("YYYY-MM-DD");
  //     const currentWeekEndDate = moment().endOf("week").format("YYYY-MM-DD");

  //     setStartingDate(currentWeekStartDate);
  //     setEndingDate(currentWeekEndDate);
  //   }
  //   // Last Month Condition
  //   else if (quickBookOptions?.value == 5) {
  //     const lastMonthStartDate = moment()
  //       .subtract(1, "month")
  //       .startOf("month")
  //       .format("YYYY-MM-DD");
  //     const lastMonthEndDate = moment()
  //       .subtract(1, "month")
  //       .endOf("month")
  //       .format("YYYY-MM-DD");

  //     setStartingDate(lastMonthStartDate);
  //     setEndingDate(lastMonthEndDate);
  //   }
  //   //currentmonth
  //   else if (quickBookOptions?.value == 6) {
  //     const currentFirstDate = moment().startOf("month").format("YYYY-MM-DD");
  //     const currentLastDate = moment().endOf("month").format("YYYY-MM-DD");

  //     setStartingDate(currentFirstDate);
  //     setEndingDate(currentLastDate);
  //   } else {
  //     setStartingDate("");
  //     setEndingDate("");
  //   }
  // }, [quickBookOptions]);

  useEffect(() => {
    // if (quickBookOptions?.value !== 2) {
    handleListData(
      startingDate,
      endingDate,
      columnFilters,
      globalFilter,
      pagination,
      sorting,
      salesTypeID,
      customerid
    );
    // }
  }, [
    salesTypeID,
    customerID,
    quickBookOptions,
    globalFilter,
    pagination,
    sorting,
    columnFilters,
  ]);

  // const formatDate = (string) => {
  //   var options = { year: "numeric", month: "long", day: "numeric" };
  //   return new Date(string).toLocaleDateString([], options);
  // };

  const formatDate = (string) => {
    return moment(string).format("YYYY-DD-MM");
  };
  const selectStyles = {
    // dropdown input css
    control: (provided, state) => ({
      ...provided,
      width: "100%",
      height: "40px",
      position: "relative",
      border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      boxShadow: state.isFocused ? "none" : "inset 0 1px 0 rgba(0, 0, 0, 0.1)", // remove box shadow when hovering
      "&:hover": {
        border: state.isFocused ? "1px solid orange" : "1px solid #ccc", // add orange outline when hovering
      },
    }),
    // dropdown menu css
    menu: () => ({
      boxShadow: "inset 0 1px 0 rgba(255, 149, 0, 0.1)",
      position: "absolute",
      "z-index": "999",
      background: "#f8f8f8",
      width: "100%",
    }),
    // dropdown option css
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? "rgba(255, 149, 0, 0.1)" : "#fff", // change hover color to light orange
      "&:hover": {
        backgroundColor: "rgba(255, 149, 0, 0.1)", // change hover color to light orange
      },
    }),
  };

  // const columns = [
  //   {
  //     name: "Sr No",
  //     selector: "RowNumber",
  //     sortable: false,
  //     width: "80px",
  //   },
  //   {
  //     name: "Invoice No",
  //     selector: "InvoiceNo",
  //     sortable: true,
  //     width: "130px",
  //   },
  //   {
  //     name: "Payment Date",
  //     selector: (row) => formatDate(row.Paymentdate),
  //     sortable: true,
  //     width: "170px",
  //   },
  //   {
  //     name: "Type",
  //     selector: "SalesType",
  //     sortable: true,
  //     width: "100px",
  //   },
  //   {
  //     name: "Payment Type",
  //     selector: "Paymenttypename",
  //     sortable: true,
  //     width: "180px",
  //   },
  //   {
  //     name: "Due Date",
  //     selector: (row) => row.DueDate == null || row.DueDate == "0000-00-00" ? "" : formatDate(row.DueDate),
  //     sortable: true,
  //     width: "160px",
  //   },
  //   {
  //     name: "Sale Date",
  //     selector: (row) => formatDate(row.SaleDate),
  //     sortable: true,
  //     width: "160px",
  //   },
  //   {
  //     name: "Payment Amount",
  //     // selector: "Paymentamount",
  //     selector: (row) => parseFloat(row["Paymentamount"]).toFixed(2),
  //     sortable: true,
  //     right: true,
  //     width: "200px",
  //   },

  //   {
  //     name: "Total",
  //     //   selector: "Total",
  //     right: true,
  //     selector: (row) => parseFloat(row["Total"]).toFixed(2),
  //     sortable: true,
  //     width: "150px",
  //   },

  //   //   {
  //   //     name: "Receipt",
  //   //     width: "150px",
  //   //     sortable: false,
  //   //     cell: (row) => (
  //   //       <Link
  //   //         className="btn btn-sm btn-outline-primary"
  //   //         to={`/sales-receipt/${row.ID}`}
  //   //       >
  //   //         <i className="fa fa-file"></i> Receipt
  //   //       </Link>
  //   //     ),
  //   //   },
  //   //   {
  //   //     name: "Action",
  //   //     width: "150px",
  //   //     cell: (row) => (
  //   //       <>
  //   //         {checkUserPermission(PERMISSION_EDIT) ? (
  //   //           <Link className="me-3" to={`/manage-customers/${row.Id}`}>
  //   //             <i className="fa fa-edit text-warning fa-2x" title="Edit"></i>
  //   //            </Link>
  //   //         ) : (
  //   //           ""
  //   //         )}
  //   //         {checkUserPermission(PERMISSION_DELETE) ? (
  //   //           <Link
  //   //             className="confirm-text"
  //   //             to="#"
  //   //             title="Delete"
  //   //             data-bs-toggle="modal"
  //   //             data-bs-target="#DeleteConfirmationModal"
  //   //             // onClick={() => handleDeletePopup(row.Id)}
  //   //           >
  //   //             <i
  //   //               className="fa fa-trash text-red fa-2x"
  //   //               data-bs-toggle="tooltip"
  //   //               title="Delete"
  //   //             ></i>
  //   //           </Link>
  //   //         ) : (
  //   //           ""
  //   //         )}
  //   //       </>
  //   //     ),
  //   //     ignoreRowClick: true,
  //   //     allowOverflow: true,
  //   //     button: true,
  //   //   },
  // ];

  let columns = useMemo(() => [
    {
      header: "Sr No",
      accessorKey: "RowNumber",
    },
    {
      header: "Invoice No",
      accessorKey: "InvoiceNo",
      // Cell: ({ row }) => (
      //   <>
      //     <Link
      //       className="text-warning word-break-data"
      //       to={`/sales-receipt/${row.original.SaleID}`}
      //     >
      //       {row.original.InvoiceNo}
      //     </Link>
      //   </>
      // ),
    },
    {
      header: "Payment Date",
      accessorKey: "PaymentDate",
      Cell: ({ row }) => {
        return moment(row.original.Paymentdate).format("YYYY-MM-DD HH:mm:ss");
      },
    },
    {
      header: "Type",
      accessorKey: "SalesType",
    },
    {
      header: "Payment Type",
      accessorKey: "Paymenttypename",
    },
    {
      header: "Due Date",
      accessorKey: "DueDate",
      Cell: ({ row }) => {
        return row.original.DueDate == null ||
          row.original.DueDate == "0000-00-00"
          ? ""
          : moment(row.original.DueDate).format("YYYY-MM-DD");
      },
    },
    {
      header: "Sale Date",
      accessorKey: "SaleDate",
      Cell: ({ row }) => {
        return moment(row.original.SaleDate).format("YYYY-MM-DD HH:mm:ss");
      },
    },
    {
      header: "Payment Amount",
      accessorKey: "Paymentamount",
      Cell: ({ row }) => {
        return parseFloat(row.original.Paymentamount).toFixed(2);
      },
    },
    {
      header: "Total",
      accessorKey: "Total",
      Cell: ({ row }) => {
        return parseFloat(row.original.Total).toFixed(2);
      },
    },
  ]);

  const downloadPDF = (rows, field) => {
    let newData = [];
    if (field === "selectedrow") {
      newData = rows.map((row) => row.original);
    } else if (field === "alldata") {
      newData = data;
    }
    console.log(newData, "newData");

    setLoading(true);
    var doc = new jsPDF("p", "pt", "a4");

    // Add the header
    let headerElement = document.querySelector("#header");
    let clonedHeader = headerElement.cloneNode(true);
    clonedHeader.style.fontSize = `10px`;
    clonedHeader.style.width = "560px";
    clonedHeader.style.margin = "1rem";

    let content = "";
    let startIndex = 1;
    let endIndex = 25;

    for (var i = 1; i <= Math.ceil(newData.length / 25); i++) {
      if (i == 1) {
        clonedHeader.style.marginTop = "2rem";
      }
      if (i > 1) {
        clonedHeader.style.marginTop = "2.5rem";
      }
      // Printing header
      content += " " + clonedHeader.outerHTML;

      // Printing table body
      content +=
        '<table style="font-size: 8px; margin-left: 1rem; margin-top: 2rem; width: 560px; border: 1px solid #f5f5f5">';
      content +=
        "<thead><tr style='margin-bottom: 5px'>" +
        '<th style="padding: 7px;">So No</th>' +
        '<th style="padding: 7px;">InvoiceNo</th>' +
        '<th style="padding: 7px;">PaymentDate</th>' +
        '<th style="padding: 7px;">SalesType</th>' +
        '<th style="padding: 7px;">Paymenttypename</th>' +
        '<th style="padding: 7px;">DueDate</th>' +
        '<th style="padding: 7px;">SaleDate</th>' +
        '<th style="padding: 7px;">Paymentamount</th>' +
        '<th style="padding: 7px;">Total</th>' +
        "</tr></thead>";
      content += "<tbody>";

      // Loop for printing items based on endIndex
      for (let index = startIndex; index <= endIndex; index++) {
        if (index <= newData.length) {
          content +=
            "<tr>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            index +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].RowNumber +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].InvoiceNo +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            moment(newData[index - 1].PaymentDate).format("DD-MM-YYY") +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].SalesType +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].Paymenttypename +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            moment(newData[index - 1].DueDate).format("DD-MM-YYY") +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            moment(newData[index - 1].SaleDate).format("DD-MM-YYY") +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            Number(newData[index - 1].Paymentamount).toFixed(2) +
            "</td>" +
            '<td style="font-size: 7px; padding: 7px;">' +
            newData[index - 1].Total +
            "</td>" +
            "</tr>";
        }

        if (index % 25 == 0) {
          startIndex = startIndex + 25;
          endIndex = endIndex + 25;
          break;
        }
      }

      content += "</tbody>";
      content += "</table>";

      content +=
        '<div style="text-align: center; width: 560px">' +
        '<p style= "text-align: center; margin-top: 1.3rem; font-size: 9px; font-weight: bold;">' +
        i +
        "</p>" +
        "</div>";
    }

    // Printing page
    doc.html(content, {
      callback: function (pdf) {
        pdf.save("Payment_List.pdf");
        setLoading(false);
      },
    });
  };

  const handleExportRows = (rows) => {
    console.log(
      rows.map((row) => row.original),
      "selected row"
    );
    // csvExporter.generateCsv(rows.map((row) => row.original));

    const workbook = XLSX.utils.book_new();
    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(rows.map((row) => row.original));
    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `Payment_List_.xlsx`);
  };
  const onBtExport = () => {
    const workbook = XLSX.utils.book_new();

    // Convert the data to a worksheet
    const worksheet = XLSX.utils.json_to_sheet(data);

    // Add the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Save the workbook as an Excel file
    XLSX.writeFile(workbook, `JobWorksDetail_.xlsx`);
  };

  const handleSort = (e, sortingDirection) => {
    setSortingId(e.id);
    setSortingDirection(sortingDirection);
    handleListData(
      1,
      perPageSize,
      searchtext,
      e.id,
      sortingDirection,
      startingDate,
      endingDate,
      salesTypeID,
      customerID
    );
  };

  const contextActions = useMemo(() => {
    const handleDeletePopup = (pID) => {
      const deleteRequestParam = {
        saleids: selectedSalesCheckboxIds,
      };
      localStorage.setItem(
        "DeleteRequestParam",
        JSON.stringify(deleteRequestParam)
      );
    };

    return (
      <button
        type="button"
        className="btn btn-danger btn-sm pull-left "
        data-bs-toggle="modal"
        data-bs-target="#DeleteConfirmationModal"
        onClick={handleDeletePopup}
      >
        <i className="fa fa-trash fa-sm" /> Delete
      </button>
    );
  }, [selectedRows, toggleCleared]);

  // useEffect(() => {
  //   setLoading(true);
  //   axios
  //     .get(
  //       `${
  //         config.salesconfigBaseUrl
  //       }/sales/salespaymentlist?pagenumber=${pagenumber}&pagesize=${perPageSize}&filtertext=${filtertext}&ordercolumn=${1}&currentorder=desc&customerid=${customerid}&startdate=${startingDate}&enddate=${endingDate}&LocationID=${localStorage.getItem(
  //         "Location"
  //       )}`,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           Authorization: token,
  //         },
  //       }
  //     )
  //     .then((res) => {
  //       console.log(res.data.ResponseData);
  //       setData(res.data.ResponseData);
  //       setTotalRows(res.data.ResponseData[0]?.TotalRecord);
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       setLoading(false);
  //     });
  // }, []);

  console.log("Data1", data);

  const handleListData = (
    startingdate,
    endingdate,
    columnFilters,
    globalFilter,
    pagination,
    sorting,
    salestypeid
  ) => {
    setLoading(true);

    // salestypeid = salestypeid > 0 ? salestypeid : 0;
    // customerid = customerid > 0 ? customerid : 0;

    const FilterColumnText = {};
    FilterColumnText.filtercolumntext = columnFilters;

    let FilterColumnSearchText = JSON.stringify(FilterColumnText);

    const columnIndex = columns.findIndex(
      (column) => column.accessorKey === sorting[0]?.id
    );

    axios
      .get(
        `${
          config.salesconfigBaseUrl
        }/sales/salespaymentlist?filtercolumnsearchtext=${FilterColumnSearchText}&pagenumber=${
          pagination.pageIndex + 1
        }&pagesize=${pagination.pageSize}&filtertext=${
          globalFilter == undefined ? "" : globalFilter
        }&ordercolumn=${columnIndex === -1 ? 1 : columnIndex}&currentorder=${
          sorting[0]?.desc === undefined
            ? "desc"
            : sorting[0]?.desc === true
            ? "desc"
            : "asc"
        }&customerid=${customerid}&&startdate=${startingDate}&enddate=${endingDate}&LocationID=${localStorage.getItem(
          "Location"
        )}`,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            Authorization: token,
          },
        }
      )
      .then((res) => {
        console.log(res.data.ResponseData);
        setData(res.data.ResponseData);
        setTotalRows(res.data.ResponseData[0]?.TotalRecord);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const handlePerRowsChange = async (page, newPerPage) => {
    setperPageSize(newPerPage);
    setCurrentPage(page);
    handleListData(page, newPerPage, searchtext, sortingId, sortingDirection);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    handleListData(page, perPageSize, searchtext, sortingId, sortingDirection);
  };

  const ChangeFilterText = (e) => {
    setSearchText(e.target.value);
    setCurrentPage(1);
    handleListData(1, perPageSize, e.target.value, sortingId, sortingDirection);
  };

  return (
    <>
      <div className={"col-lg-10 col-md-12"}>
        <div className="card bg-white">
          <div className="d-flex  w-100 mr-2 mt-2">
            {/* <div className="p-3 col-lg-3 col-md-6 col-sm-12 pt-4 h-25">
              <input
                type="search"
                placeholder="Search..."
                className="search-btn form-control form-control-sm  w-100 pull-right"
                onChange={ChangeFilterText}
                value={searchtext}
              />
            </div> */}

            <div className="p-1 col-lg-3 col-md-6 col-sm-12">
              Date Filter:
              <Select
                defaultValue={quickBookOptions}
                onChange={(event) => {
                  handleQuickBookChange(event);
                }}
                options={options}
                backspaceRemovesValue={false}
                controlShouldRenderValue={true}
                isClearable={true}
                // hideSelectedOptions={true}
                styles={selectStyles}
                className="custom-search-select"
              />
            </div>
            {quickBookOptions?.value == 2 && (
              <>
                <div className="p-1 col-lg-2 col-md-6 col-sm-12">
                  Custom Start Date:
                  <input
                    type="date"
                    className="form-control mt-1"
                    id="StartDate"
                    name="StartDate"
                    onChange={(event) => handleChangeCustomStartingDate(event)}
                  />
                </div>
                <div className="p-1 col-lg-2 col-md-6 col-sm-12">
                  Custom End Date:
                  <input
                    type="date"
                    className="form-control mt-1"
                    id="EndDate"
                    name="EndDate"
                    onChange={(event) => handleChangeCustomEndingDate(event)}
                  />
                </div>
              </>
            )}
            {quickBookOptions?.value == 2 && (
              <div className="p-1 col-lg-1 col-md-6 col-sm-12 mt-4">
                <button
                  className="btn btn-dark"
                  onClick={() => handleSearchAccordingToDate()}
                >
                  {" "}
                  Search{" "}
                </button>
              </div>
            )}
          </div>
          <div className="card-body">
            {/* {loading===true ? <img src="https://media1.giphy.com/media/3oEjI6SIIHBdRxXI40/200w.gif?cid=6c09b952aaofoxh8qm6a3zgph6qs4lb6g3th0j1mckaenmzo&ep=v1_gifs_search&rid=200w.gif&ct=g" class="text-right" alt=""/> : */}
            <div className="email-header">
              <div className="row">
                <div className="col-lg-15 top-action-left col-sm-20">
                  <div className="float-left table-responsive">
                    {/* <DataTable
                      title="Received Payments"
                      columns={columns}
                      data={data}
                      progressPending={loading}
                      pagination
                      paginationServer
                      paginationTotalRows={totalRows}
                      paginationDefaultPage={currentPage}
                      onChangeRowsPerPage={(e) => {
                        handlePerRowsChange(1, e);
                      }}
                      onChangePage={handlePageChange}
                      highlightOnHover
                      striped
                      responsive
                      paginationRowsPerPageOptions={[25, 50, 100, 500]}
                      persistTableHead
                      // selectableRows
                      sortServer
                      onSort={handleSort}
                      contextActions={contextActions}
                      // onSelectedRowsChange={handleRowSelected}
                      clearSelectedRows={toggleCleared}
                      dense
                      paginationPerPage={perPageSize}
                    /> */}

                    {/* Receipt */}
                    <div className="container" style={{ display: "none" }}>
                      <div className="col-md-12 text-center" id="header">
                        <h2>Jarkan</h2>
                        <p className="fw-bold">Sales Report</p>
                        <div className="row">
                          {(customStartingDate || customEndingDate) && (
                            <>
                              <p>
                                Date: {customStartingDate} to {customEndingDate}
                              </p>
                            </>
                          )}
                        </div>
                      </div>
                      <hr />
                    </div>

                    <MaterialReactTable
                      columns={columns}
                      data={data}
                      enableColumnResizing
                      enableGrouping
                      enableStickyHeader
                      enableStickyFooter
                      enableRowSelection
                      // enableRowSelection={listid === 4 ? false : true}
                      enableColumnOrdering
                      renderTopToolbarCustomActions={({ table }) => (
                        <Box
                          sx={{
                            display: "flex",
                            gap: "1rem",
                            p: "0.5rem",
                            flexWrap: "wrap",
                          }}
                        >
                          {console.log(table, "tables")}

                          <Button
                            size="small"
                            color="primary"
                            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                            onClick={onBtExport}
                            startIcon={<FileDownloadIcon />}
                            variant="contained"
                          >
                            Export All In Excel
                          </Button>
                          <Button
                            size="small"
                            disabled={
                              !table.getIsSomeRowsSelected() &&
                              !table.getIsAllRowsSelected()
                            }
                            //only export selected rows
                            onClick={() =>
                              handleExportRows(table.getSelectedRowModel().rows)
                            }
                            startIcon={<FileDownloadIcon />}
                            variant="contained"
                          >
                            Export Selected Rows in Excel
                          </Button>
                          <Button
                            size="small"
                            color="primary"
                            //export all data that is currently in the table (ignore pagination, sorting, filtering, etc.)
                            onClick={() => downloadPDF("", "alldata")}
                            startIcon={<FileDownloadIcon />}
                            variant="contained"
                          >
                            Export All In Pdf
                          </Button>
                          <Button
                            size="small"
                            disabled={
                              !table.getIsSomeRowsSelected() &&
                              !table.getIsAllRowsSelected()
                            }
                            //only export selected rows
                            onClick={() =>
                              downloadPDF(
                                table.getSelectedRowModel().rows,
                                "selectedrow"
                              )
                            }
                            startIcon={<FileDownloadIcon />}
                            variant="contained"
                          >
                            Export Selected Rows in Pdf
                          </Button>
                        </Box>
                      )}
                      initialState={{
                        density: "compact",
                        expanded: true, //expand all groups by default
                        // grouping: [""], //an array of columns to group by by default (can be multiple)
                        pagination: { pageIndex: 0, pageSize: 25 },
                        sorting: [{ id: "state", desc: false }], //sort by state by default
                      }}
                      // muiToolbarAlertBannerChipProps={{ color: "primary" }}
                      // muiTableContainerProps={{ sx: { maxHeight: 700 } }}
                      muiTablePaginationProps={{
                        rowsPerPageOptions: [25, 50, 100, 300, 500],
                      }}
                      muiTableContainerProps={{
                        sx: { maxHeight: "fit-content" },
                      }}
                      // manualFiltering
                      manualPagination
                      manualSorting
                      muiToolbarAlertBannerProps={
                        isError
                          ? {
                              color: "error",
                              children: "Error loading data",
                            }
                          : undefined
                      }
                      // onColumnFiltersChange={setColumnFilters}
                      onGlobalFilterChange={setGlobalFilter}
                      onPaginationChange={setPagination}
                      onSortingChange={setSorting}
                      rowCount={totalRows}
                      state={{
                        // columnFilters,
                        globalFilter,
                        isLoading,
                        pagination,
                        showAlertBanner: isError,
                        showProgressBars: isRefetching,
                        sorting,
                      }}
                    />

                    {/* <Table columns={columns} dataSource={data} /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Paymentlisting;
